   import {createNativeStackNavigator} from '@react-navigation/native-stack';
   import {OnboardingProvider} from './OnboardingContext';
   import Welcome from './Welcome';
   import RefuelFrequency from './RefuelFrequency';
   import FuelType from './FuelType';
   import SavingsRadar from './SavingsRadar';
   import SavingsSummary from './SavingsSummary';

   const Stack = createNativeStackNavigator();

   const OnboardingNavigator = () => (
     <OnboardingProvider>
       <Stack.Navigator
         initialRouteName="Welcome"
         screenOptions={{headerShown: false}}>
         <Stack.Screen name="Welcome" component={Welcome} />
         <Stack.Screen name="RefuelFrequency" component={RefuelFrequency} />
         <Stack.Screen name="FuelType" component={FuelType} />
         <Stack.Screen name="SavingsRadar" component={SavingsRadar} />
         <Stack.Screen name="SavingsSummary" component={SavingsSummary} />
       </Stack.Navigator>
     </OnboardingProvider>
   );

   export default OnboardingNavigator;